import React, { PureComponent } from 'react';

import { inject, observer } from 'mobx-react';
import { CommunityService } from 'modules/community';
import { userDataPropType } from 'modules/community/commentList/DataPropType';
import PropTypes from 'prop-types';

import './UsersListOption.scss';

@inject((stores) => ({
  dataTableParams: stores.CommunityStore.dataTableParams
}))
@observer
export default class UsersListOption extends PureComponent {
  static propTypes = {
    fetchData: PropTypes.func,
    setUserValue: PropTypes.func,
    usersData: PropTypes.shape(userDataPropType),
    dataTableParams: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.selectUser = this.selectUser.bind(this);
  }

  selectUser(user) {
    const { fetchData, setUserValue, dataTableParams } = this.props;
    const newDataTableParams = { ...dataTableParams };

    CommunityService.setDataTableParamsPagination(newDataTableParams, 0);
    CommunityService.setData({ page: 0 });
    setUserValue && setUserValue(user);
    fetchData && fetchData(CommunityService.commentListParams);
  }

  render() {
    const { usersData } = this.props;

    if (!(usersData && usersData.content)) {
      return null;
    }

    return usersData.content.map((user) => (
      <div
        key={user.id}
        className="comment-list__filter__input__result__data"
        onClick={() => this.selectUser(user)}
      >
        <div className="comment-list__filter__input__result__data__username">
          {user.userName}
        </div>

        <div className="comment-list__filter__input__result__data__email">
          {user.userEmail}
        </div>
      </div>
    ));
  }
}
